import PyTorch from '../images/PyTorch.png';
import python from '../images/python.png';
import scikit from '../images/scikit.png';
import keras from '../images/keras.png';
import Matplotlib from '../images/Matplotlib.png';
import nn from '../images/nn.png';
import js from '../images/js.png';
import andriodstudio from '../images/andriodstudio.png';
import mysql from '../images/mysql.png';
import mongodb from '../images/mongodb.png';
import firebase from '../images/firebase.png';
import Jupyter from '../images/Jupyter.png';
import Tensorflow from '../images/Tensorflow.png';
import jquery from '../images/jquery.png';
import strapi from '../images/strapi.png';
import css from '../images/css.png';
import bootstrap from '../images/bootstrap.png';
import html from '../images/html.png';
import react from '../images/react.png';
import reactnative from '../images/reactnative.png';
import dotnet from '../images/dotnet.png';
import angular from '../images/angular.png';
import express from '../images/express.png';
import node from '../images/node.png';
import studio from '../images/studio.png';
import vscode from '../images/vscode.png';
import git from '../images/git.png';
import github from '../images/github.png';
import rapidapi from '../images/rapidapi.png';
import figma from '../images/figma.png';
import netlify from '../images/netlify.png';
import ybi from '../images/ybi.jpg';
import oasis from '../images/oasis.jpg';
import internship1 from '../images/internship1.png';
import internship2 from '../images/internship2.png';
import reactcerti from '../images/reactcerti.png';
import pycerti from '../images/pycerti.jpg';
import webcerti from '../images/webcerti.png';
import edyoda from '../images/edyoda.jpg';
import udemy from '../images/udemy.png';
import furquan from '../images/furquan.jpeg';
import travel from '../images/travel.png';
import vehicle from '../images/vehicle.jpg';
import careme from '../images/careme.png';
import ou2 from '../images/ou2.jpeg';
import cgr from '../images/cgr.png';
import nims from '../images/nims.png';
import chaitanya from '../images/chaitanya.png';
import mitius from '../images/mitius.jpeg';
import langchain from '../images/lanchain.png';
import tectorologo from '../images/tectorologo.png'
import tenderprism from '../images/tenderprism.jpg';
import kau from '../images/kau.jpeg';
import pyomo from '../images/pyomo.jpg';
import mtslogo from '../images/MTS-logo.png';
import sendmails from '../images/sendmails.png'
import smartRad from '../images/smartRad.png'
import codexarlogo from '../images/codexar.png';

export const Bio = {
  name: "Mohammed Furquan Saleem",
  roles: [
    "AI/ML Engineer",
    "GenAI Engineer",
    "Data Scientist",
    "Python Programmer",
  ],
  description:
    "I hold the position of AI/ML Engineer at Tectoro Consulting Pvt. Ltd. I graduated with a B.E. in Computer Science, specializing in Artificial Intelligence and Machine Learning (AIML). Throughout my academic journey, I immersed myself in the world of AI and ML, undertaking various projects to enhance my skills and knowledge. Additionally, I possess proficiency in web and mobile app development.",
  github: "https://github.com/furquanSal",
  resume:
    "https://drive.google.com/file/d/1MVfOijHJc8r-ERZa4w6ihBQXWw1bBye-/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/furquansal/",
  twitter: "https://twitter.com/furquan_sal",
  insta: "https://www.instagram.com/er.furquansaleem/",
  facebook: "https://www.facebook.com/mohammed.furquan.142/",
};

export const skills = [
  {
    title: "AI & ML",
    skills: [
      {
        name: "PyTorch",
        image: PyTorch
      },
      {
        name: "Python",
        image: python
      },
      {
        name: "Scikit-Learn",
        image: scikit,
      },
      {
        name: "LangChain",
        image: langchain,
      },
      {
        name: "Keras",
        image: keras
      },
      {
        name: "Jupyter",
        image: Jupyter
      },
      {
        name: "TensorFlow",
        image: Tensorflow
      },
      {
        name: "Matplotlib",
        image: Matplotlib
      },
      {
        name: "Neural Networks",
        image: nn
      },
      {
        name: "Pyomo",
        image: pyomo
      },
    ],
  },
  {
    title: "Web Development",
    skills: [
      {
        name: "ReactJS",
        image: react
      },
      {
        name: "HTML5",
        image: html
      },
      {
        name: "CSS",
        image: css
      },
      {
        name: "JavaScript",
        image: js
      },
      {
        name: "Bootstrap",
        image: bootstrap
      },
      {
        name: "Firebase",
        image: firebase
      },
      {
        name: "MongoDB",
        image: mongodb
      },
      {
        name: "MySQL",
        image: mysql
      },
      {
        name: "jQuery",
        image: jquery,
      },
      {
        name: "DotNet",
        image: dotnet,
      },
      {
        name: "NodeJS",
        image: node,
      },
    ],
  },
  {
    title: "App Development",
    skills: [
      {
        name: "React Native",
        image: reactnative
      },
      {
        name: "Strapi",
        image: strapi,
      },
      {
        name: "ExpoGO",
        image:
          "https://www.cdnlogo.com/logos/e/72/expo-go-app.svg",
      },
      {
        name: "JavaScript",
        image: js
      },
      {
        name: "Firebase",
        image: firebase
      },
      {
        name: "Android Studio",
        image: andriodstudio,
      },
    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Visual Studio",
        image: studio,
      },
      {
        name: "VS Code",
        image: vscode,
      },
      {
        name: "Git",
        image: git,
      },
      {
        name: "GitHub",
        image: github,
      },
      {
        name: "Angular",
        image: angular,
      },
      {
        name: "ExpressJS",
        image: express,
      },
      {
        name: "RapidAPI",
        image: rapidapi,
      },
      {
        name: "Netlify",
        image: netlify,
      },
      {
        name: "Figma",
        image: figma
      },
    ],
  },
];

export const experiences = [
  {
    id: 0,
    img: codexarlogo,
    role: "Lead AI Engineer",
    company: "CodexAR Pvt. Ltd.",
    date: "Oct. 2025 - Present",
    desc: "Working on various AI/ML use cases.",
    skills: [
      "Generative AI (GenAI),",
      "Prompt Engineering",
      "Augmented Reality",
      "Advanced Python Programming",
      "ML Applications"
    ],
    // doc: "None",
  },
  {
    id: 1,
    img: tectorologo,
    role: "Mid-Level Lead & AI/ML Engineer",
    company: "Tectoro Consulting Pvt. Ltd.",
    date: "Sept. 2024 - Oct. 2025",
    desc: "Working on various AI/ML use cases.",
    skills: [
      "Generative AI (GenAI),",
      "Fine tuning YOLO models,",
      "Deep Learning"
    ],
    // doc: "None",
  },
  {
    id: 2,
    img: mitius,
    role: "Associate GenAI Developer",
    company: "Millennium Info Tech Ltd.",
    date: "Jan 2024 - Aug 2024",
    desc: "Worked with GenAI-driven projects.",
    skills: [
      "Generative AI (GenAI),",
      "LangChain,",
      "Chatbot development"
    ],
    // doc: "None",
  },
  {
    id: 3,
    img: mtslogo,
    role: "AI Program Associate",
    company: "MOFUSA Tech Solutions",
    date: "Mar 2022 - Dec 2023",
    desc: "Worked and Researched on AI tools and frameworks.",
    skills: [
      "Pytorch",
      "TensorFlow",
      "CNN",
      "Deep Learning"
    ],
    // doc: "None",
  },
  {
    id: 4,
    img: oasis,
    role: "Web Developer Intern",
    company: "Oasis Infobyte",
    date: "June 2023 - July 2023",
    desc: "Created static and dynamic websites.",
    skills: [
      "HTML5,",
      "CSS,",
      "JavaScript,",
      "ReactJS,",
      "MongoDB,",
      "jQuery",
    ],
    doc: internship1,
  },
  {
    id: 5,
    img: ybi,
    role: "Data Science and Machine Learning Intern",
    company: "YBI Foundation",
    date: "May 2023 - June 2023",
    desc: "Worked with multiple dataset and trained machine learning model.",
    skills: [
      "Machine Learning,",
      "Deep Learning,",
      "Python",
    ],
    doc: internship2,
  },
];

export const certifications = [
  // {
  //   id: 0,
  //   img: udemy,
  //   name: ".NET8 Core MVC",
  //   company: "Udemy",
  //   date: "December 06, 2023",
  //   certID: "UC-d2c8293a-4a6e-4975-bcf2-e62c28fbd63c",
  //   skills: [
  //     "C#,",
  //     "Angular,",
  //     "ReactJS,",
  //     "MVC,",
  //     "Visual Studio",
  //   ],
  //   doc: dotnetcerti,
  // },
  {
    id: 1,
    img: udemy,
    name: "Python",
    company: "Udemy",
    date: "October 27, 2023",
    certID: "UC-f3f9d5c3-fb49-49ad-b705-d714f2ee8ea3",
    skills: [
      "Python,",
      "Web Development,",
      "Flask,",
      "Django",
    ],
    doc: pycerti,
  },
  {
    id: 2,
    img: edyoda,
    name: "ReactJS",
    company: "Edyoda University",
    date: "August 06, 2023",
    certID: "FSR291222B-12103-41",
    skills: [
      "ReactJS,",
      "JavaScript,",
      "JSON,",
      "JSX",
    ],
    doc: reactcerti,
  },
  {
    id: 3,
    img: edyoda,
    name: "Web Development",
    company: "Edyoda University",
    date: "MAy 14, 2023",
    certID: "FSR291222B-12103-31",
    skills: [
      "HTML5,",
      "CSS,",
      "JavaScript",
    ],
    doc: webcerti,
  },
];

export const education = [
  {
    id: 0,
    img: ou2 , 
    school: "Osmania University, Hyderabad",
    date: "",
    grade: "9.60 CGPA (most recent semester)",
    desc: "I recently began my MBA program, which will provide me with advanced business knowledge and leadership skills. Through this program, I aim to develop expertise in areas such as strategic management, financial analysis, marketing, and organizational behavior, enhancing my ability to make informed decisions and lead effectively in a competitive business environment.",
    degree: "Master of Business Administration",
  },
  {
    id: 1,
    img: ou2 , 
    school: "Osmania University, Hyderabad",
    date: "",
    grade: "8.0 CGPA (Distinction)",
    desc: "I graduated from the Computer Science Engineering program with a specialization in Artificial Intelligence and Machine Learning at Osmania University in June 2024, with a CGPA of 8.0 and passed with distinction. Over the course of my four-year engineering program, I acquired a comprehensive understanding of various concepts within the field of artificial intelligence, machine learning, and deep learning. My expertise extends to essential tasks such as data pre-processing, data cleaning, and the development of machine learning models. Additionally, I possess proficiency in managing databases, particularly MySQL, and have a solid understanding of SQL. Furthermore, my education encompassed a broad spectrum of topics, including computer networks and compiler design. These courses have equipped me with a well-rounded knowledge base, enhancing my capabilities in the realm of computer science and engineering.",
    degree: "Bachelor of Engineering - Computer Science and Engineering with specialization in AI/ML",
  },
  {
    id: 2,
    img: chaitanya,     
    school: "Sri Chaitanya Junior Kalasala, Hyderabad",
    date: "",
    grade: "88.1%",
    desc: "Completed my intermediate education in the 11th and 12th grades under the Telangana State Board of Intermediate Education, specializing in the stream of Mathematics, Physics, and Chemistry. I secured an excellent overall percentage of 88.1% during these two years.",
    degree: "Telangana State Board of Intermediate Education (TSBIE)",
  },
  {
    id: 3,
    img: cgr,
    school: "CGR International School, Hyderabad",
    date: "",
    grade: "A",
    desc: "Completed my 10th-grade education from the Central Board of Secondary Education (CBSE) in 2018, securing an outstanding grade A.",
    degree: "Central Board of Secondary Education (CBSE)",
  },
  {
    id: 4,
    img: nims,
    school: "New Indian Model School, Dubai",
    date: "",
    grade: "A",
    desc: "Completed studies from LKG to 8th standard at NIMS, Dubai, under the CBSE board, achieving high grades and participating in many co-curricular activities.",
    degree: "Central Board of Secondary Education (CBSE)",
  },
];

export const projects = [
  {
    id: 3,
    title: "SmartRad",
    date: "Jan 23, 2025",
    codeStatus: "Confidential",
    liveDemoStatus: "Available",
    description:
      "SmartRad is a web-based radiology reporting platform that leverages generative AI to streamline the reporting process for radiologists. By recognizing diverse accents, including Indian, South Asian, and Arab, it ensures accurate voice-to-text conversion. The platform automates formatting, punctuation, and structuring of reports, allowing radiologists to focus on diagnostics. With its intuitive interface, users can easily make revisions through a simple click-and-drag mechanism. SmartRad aims to reduce dictation time by up to 90% and accelerate reporting by up to 50%, enhancing efficiency and precision in radiological practices.",
    image: smartRad,
    tags: [
      "Python",
      "OpenAI",
      "LangChain",
      "RestAPIs",
    ],
    category: "machine learning",
    github: "nil",
    webapp: "https://radiogram.com/products/smartRad",
    member: [
      {
        name: "Mohammed Furquan Saleem",
        img: furquan,
        linkedin: "https://www.linkedin.com/in/furquansal/",
        github: "https://github.com/furquanSal/",
      },
    ]
  },
  {
    id: 13,
    title: "Tender Prism",
    codeStatus: "Confidential",
    liveDemoStatus: "Confidential",
    date: "Aug 23, 2024",
    description:
      "The Tender Prism project is an AI-powered tool designed to quickly summarize tender documents, making it easier to grasp key points instantly. Using natural language processing (NLP), it extracts critical information without altering the meaning, offering summaries in either bullet points or paragraphs. Features include accurate condensed text, copy functionality, and the ability to download results in DOC format. The tool enhances productivity by providing instant results and is especially useful for skimming large documents, boosting study processes, and saving time on reading lengthy tenders.",
    image: tenderprism,
    tags: ["Python", "OpenAI", "Flask", "Langchain", "APIs"],
    category: "machine learning",
    github: "nil",
    webapp: "nil",
    member: [
      {
        name: "Mohammed Furquan Saleem",
        img: furquan,
        linkedin: "https://www.linkedin.com/in/furquansal/",
        github: "https://github.com/furquanSal/",
      },
      {
        name: "Kausthubha Chekuri",
        img: kau,
        linkedin: "https://www.linkedin.com/in/kausthubha-chekuri-1a3a18131/",
        github: "https://github.com/KausthubhaChekuri",
      },
    ]
  },
  {
    id: 8,
    title: "SendMails App",
    codeStatus: "Available",
    liveDemoStatus: "Available",
    date: "April 30, 2025",
    description:
      "SendMails is a browser-based bulk email sending application built for professionals who value simplicity, speed, and security. Whether you're an email marketer, freelancer, educator, or job seeker, SendMails lets you send personalized messages to multiple recipients with just a few clicks. Featuring a clean, intuitive interface and secure SMTP delivery using Python’s smtplib, it requires no installation and makes mass communication effortless.",
    image: sendmails,
    tags: ["Python", "SMTP", "Google Mails", "APIs"],
    category: "web app",
    github: "https://github.com/furquanSal/Bulk-Email-Sender-App",
    webapp: "https://sendmails.streamlit.app/",
    member: [
      {
        name: "Mohammed Furquan Saleem",
        img: furquan,
        linkedin: "https://www.linkedin.com/in/furquansal/",
        github: "https://github.com/furquanSal/",
      },
    ]
  },
  {
    id: 9,
    title: "Travel Advisor App",
    date: "Jul 25, 2023",
    codeStatus: "Available",
    liveDemoStatus: "Available",
    description:
      " Designed and developed a Travel Advisor application using React.js seamlessly integrating the Travel Advisor API and Google-APIs. Enabled dynamic search, filtering, and location-based recommendations for restaurants, hotels, and attractions. Demonstrated expertise in React.js and effective API utilization.",
    image: travel,
    tags: [
      "React Js",
      "MongoDb",
      "NodeJS",
      "ExpressJS",
      "RestAPIs",
    ],
    category: "web app",
    github: "https://github.com/furquanSal/Travel-Advisor-App.git",
    webapp: "https://travel-advisor-app-furquan.netlify.app/",
    member: [
      {
        name: "Mohammed Furquan Saleem",
        img: furquan,
        linkedin: "https://www.linkedin.com/in/furquansal/",
        github: "https://github.com/furquanSal/",
      },
    ]
  },
  {
    id: 10,
    title: "CareME360 Mobile App",
    date: "Dec 17, 2023",
    codeStatus: "Available",
    liveDemoStatus: "Currently Unavailable",
    description:
      "Introducing careME360, a cross-platform mobile app revolutionizing healthcare accessibility. Seamlessly find nearby hospitals and doctors based on live location, with an emergency button connecting users to the nearest hospital's ambulance instantly. Beyond location services, the app offers a suite of health features, including BMI calculation, AI-driven support for mental health, and personalized medicine reminders. Experience comprehensive healthcare at your fingertips with careME360.",
    image: careme,
    tags: ["React Native", "JavaScript", "Axios", "Strapi", "CLerk", "APIs"],
    category: "android app",
    github: "https://github.com/furquanSal/careME360.git",
    webapp: "https://as1.ftcdn.net/v2/jpg/01/26/39/54/1000_F_126395469_FnlY3ZgaAZaosjmSbkgA3I5sS3UXN78T.jpg",
    member: [
      {
        name: "Mohammed Furquan Saleem",
        img: furquan,
        linkedin: "https://www.linkedin.com/in/furquansal/",
        github: "https://github.com/furquanSal/",
      },
    ]
  },
  {
    id: 2,
    title: "Vehicle Detection",
    date: "Oct 16, 2023",
    codeStatus: "Available",
    liveDemoStatus: "Currently Unavailable",
    description:"Developed an advanced vehicle detection and counting model using YOLOv5, enhancing object recognition and tracking capabilities. The project showcases proficiency in computer vision and deep learning, providing accurate and efficient solutions for traffic monitoring and analysis.",
    image: vehicle,
    tags: ["Python", "Keras", "TensorFlow", "yoloV5", "cv2", "Numpy"],
    category: "machine learning",
    github: "https://github.com/furquanSal/vehicle-detector.git",
    webapp: "https://as1.ftcdn.net/v2/jpg/01/26/39/54/1000_F_126395469_FnlY3ZgaAZaosjmSbkgA3I5sS3UXN78T.jpg",
    member: [
      {
        name: "Mohammed Furquan Saleem",
        img: furquan,
        linkedin: "https://www.linkedin.com/in/furquansal/",
        github: "https://github.com/furquanSal/",
      },
    ]
  },
  // {
  //   id: 0,
  //   title: "ToDo Webapp",
  //   date: "Feb 03, 2023",
  //   codeStatus: "Available",
  //   liveDemoStatus: "Available",
  //   description:
  //     "Developed a dynamic ToDo list web application using HTML, CSS, and JavaScript, featuring an intuitive user interface. Implemented seamless Light Mode/Dark Mode functionality to enhance user experience and foster productivity.",
  //   image: todo,
  //   tags: [
  //     "HTML5",
  //     "Bootstrap",
  //     "CSS",
  //     "JSON",
  //     "JavaScript",
  //   ],
  //   category: "web app",
  //   github: "https://github.com/furquanSal/todo-webapp.git",
  //   webapp: "https://furquansal.github.io/todo-webapp/",
  //   member: [
  //     {
  //       name: "Mohammed Furquan Saleem",
  //       img: furquan,
  //       linkedin: "https://www.linkedin.com/in/furquansal/",
  //       github: "https://github.com/furquanSal/",
  //     },
  //   ]
  // },
  // {
  //   id: 1,
  //   title: "E-Commerce",
  //   date: "Nov 11, 2023",
  //   codeStatus: "Available",
  //   liveDemoStatus: "Available",
  //   description:"Designed and developed a dynamic e-commerce website for wireless earphones using HTML, CSS, and JavaScript, seamlessly blending functionality with an engaging user interface for an enhanced online shopping experience.",
  //   image:ecommerce,
  //   tags: [
  //     "HTML5",
  //     "CSS",
  //     "JavaScript",
  //     "Bootstrap",
  //     "JSON",
  //   ],
  //   category: "web app",
  //   github: "https://github.com/furquanSal/WirelessEarphones-eCommerceWebsite.git",
  //   webapp: "https://famous-valkyrie-ee04b6.netlify.app/",
  //   member: [
  //     {
  //       name: "Mohammed Furquan Saleem",
  //       img: furquan,
  //       linkedin: "https://www.linkedin.com/in/furquansal/",
  //       github: "https://github.com/furquanSal/",
  //     },
  //   ]
  // },
  // {
  //   id: 4,
  //   title: "Basic Admin Panel",
  //   codeStatus: "Available",
  //   liveDemoStatus: "Available",
  //   date: "Dec 19, 2022",
  //   description: "Designed and developed a robust admin panel webpage leveraging HTML, CSS, and JavaScript, with a significant emphasis on JavaScript for enhanced functionality. The project seamlessly integrates a user-friendly interface with dynamic features, showcasing the intersection of design and JavaScript-driven interactivity.",
  //   image:adminpanel,
  //   tags: ["ReactJs", "JSON", "JavaScript", "HTML5","CSS"],
  //   category: "web app",
  //   github: "https://github.com/furquanSal/basicadminpanel.git",
  //   webapp: "https://furquansal.github.io/basicadminpanel/",
  //   member: [
  //     {
  //       name: "Mohammed Furquan Saleem",
  //       img: furquan,
  //       linkedin: "https://www.linkedin.com/in/furquansal/",
  //       github: "https://github.com/furquanSal/",
  //     },
  //   ]
  // },
  // {
  //   id: 7,
  //   title: "Quiz App",
  //   date: "Mar 04, 2023",
  //   codeStatus: "Available",
  //   liveDemoStatus: "Available",
  //   description:
  //     "Engineered an engaging Quiz Webpage utilizing HTML, CSS, and JavaScript, with a pivotal focus on JavaScript for dynamic functionality. Implemented a scoring system to reward correct answers, delivering an interactive and educational user experience that seamlessly combines design elements with JavaScript-driven interactivity.",
  //   image:quiz,
  //   tags: ["HTML5", "CSS", "JavaScript", "XML", "JSON"],
  //   category: "web app",
  //   github: "https://codepen.io/furquan-sal/pen/xxarKXJ",
  //   webapp: "https://codepen.io/furquan-sal/full/xxarKXJ",
  //   member: [
  //     {
  //       name: "Mohammed Furquan Saleem",
  //       img: furquan,
  //       linkedin: "https://www.linkedin.com/in/furquansal/",
  //       github: "https://github.com/furquanSal/",
  //     },
  //   ]
  // },
  // {
  //   id: 8,
  //   title: "SOP Generator",
  //   date: "Sept 04, 2023",
  //   description:
  //     "Pioneered an innovative Statement of Purpose (SOP) Generator that enables users to input their information through a form, generates a personalized SOP using advanced natural language processing, and promptly delivers the customized document to their provided email address, exemplifying a harmonious blend of cutting-edge technology and user-centric design.",
  //   image: sop,
  //   tags: ["Python", "openAI", "flask", "Nodemailer", "ReactJS", "APIs"],
  //   category: "machine learning",
  //   github: "https://github.com/furquanSal/SOP-Generator.git",
  //   webapp: "https://drive.google.com/file/d/18ZHP_nFn2gscF_xRl2zdsLKy9KoZiABG/view",
  //   member: [
  //     {
  //       name: "Mohammed Furquan Saleem",
  //       img: furquan,
  //       linkedin: "https://www.linkedin.com/in/furquansal/",
  //       github: "https://github.com/furquanSal/",
  //     },
  //   ]
  // },
];

export const TimeLineData = [
  { year: 2017, text: "Started my journey" },
  { year: 2018, text: "Worked as a freelance developer" },
  { year: 2019, text: "Founded JavaScript Mastery" },
  { year: 2020, text: "Shared my projects with the world" },
  { year: 2021, text: "Started my own platform" },
];
